import React, { useMemo } from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';

import './style.scss';
import CButton from '../CButton';

/**
 * @param {array} tags Array of tags
 * @param {string} tag Name of tag
 * @param {array} selectedTags Array of selected tags id
 * @param {string} className String with additional classes
 * @param {boolean} gap Wrap tags or show one line 
 * @param {boolean} clickable Add tags clickable handler
 * @param {boolean} single Simple single tag
 * @param {string} size normal or small value for tag size
 * @param {function} onChange On tag click callback
 * @returns {ReactComponent}
 */

const CTags = ({
    tags = [],
    tag = '',
    selectedTags = [],
    className = '',
    gap = true,
    clickable = false,
    single = false,
    size = 'normal',
    onChange,
    onReset,
}) => {
    const $locale = useLocaleContext();

    const tagsList = useMemo(() => {
        if (!single) return tags;

        return [tag];
    }, [tags, tag])

    function handleSelectTag(e, tagId) {
        e.preventDefault();
        
        if (!clickable) return;

        onChange(tagId);
    }

    function handleReset(e) {
        e.preventDefault();

        onReset();
    }

    return (
        !!tagsList.length
            ? <div
                className={`c-tags ${className}`}
                style={{
                    gap: gap ? '5px' : 0
                }}
            >
                {
                    tagsList?.map((tagItem, index) => (
                        <a
                            key={index}
                            href=""
                            className={`c-tags-tag ${!clickable ? 'c-tags-tag--blocked' : ''} c-tags-tag--${size} ${!single && selectedTags.includes(tagItem.id) ? 'c-tags-tag--selected' : ''} ${single ? 'c-tags-tag--single' : ''} ${tagItem.color ? 'c-tags-tag--colored' : ''}`}
                            style={{'--tag-color': !single ? tagItem.color || 'var(--app-additional-color-3)' : 'var(--app-additional-color-3)'}}
                            onClick={(e) => handleSelectTag(e, !single ? tagItem.id : tagItem)}
                        >
                            <span className="c-tags-tag__name">
                                {!single ? $locale.getProperty(tagItem, 'title') : tagItem}
                            </span>
                            {
                                (clickable && selectedTags.includes(tagItem.id))&&
                                    <CButton
                                        blank
                                        icon="close"
                                        className="c-tags-tag__unselect"
                                        onClick={(e) => handleSelectTag(e, tagItem.id)}
                                    />
                            }
                        </a>
                    ))
                }
                {
                    (clickable && !!selectedTags.length) &&

                    <a
                        href=""
                        className={`c-tags-tag c-tags-tag--reset`}
                        onClick={(e) => handleReset(e)}
                    >
                        <span className="c-tags-tag__name">
                            {$locale.get('label.reset.all')}
                        </span>
                        <CButton
                            blank
                            icon="close"
                            className="c-tags-tag__unselect"
                            onClick={(e) => handleReset(e)}
                        />
                    </a>
                }
            </div>
        : <></>
    )
};

export default CTags;
